<ng-template #content let-modal>
    <div class="modal-header">
        <h5 class="modal-title">{{ "government_scores.pillars.area_of_focus.title" | translate }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" [formGroup]="areaOfFocusForm">
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameAE' | translate"
                    formControlName="areaNameAE"
                    controlName="areaNameAE"
                    [invalid]="submitted() && areaOfFocusForm.get('areaNameAE')?.invalid!"
                    [required]="true"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.nameEN' | translate"
                    formControlName="areaNameEN"
                    controlName="areaNameEN"
                    [invalid]="submitted() && areaOfFocusForm.get('areaNameEN')?.invalid!"
                    [required]="true"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionAE' | translate"
                    formControlName="areaDscAE"
                    controlName="areaDscAE"
                    [invalid]="submitted() && areaOfFocusForm.get('areaDscAE')?.invalid!"
                    [isTextArea]="true"
                />
            </div>
            <div class="col-sm-6 col-xs-12">
                <adaa-form-input
                    [label]="'common.form.label.descriptionEN' | translate"
                    formControlName="areaDscEN"
                    controlName="areaDscEN"
                    [invalid]="submitted() && areaOfFocusForm.get('areaDscEN')?.invalid!"
                    [isTextArea]="true"
                />
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">
            {{ pageMode() === PageMode.view ? ("common.form.button.close" | translate) : ("common.form.button.cancel" | translate) }}
        </button>
        @if (pageMode() !== PageMode.view) {
            <button type="button" class="btn btn-primary" (click)="submit()">{{ "common.form.button.save" | translate }}</button>
        }
    </div>
</ng-template>
